
import Vue from 'vue';
import store from '../store/store.js'
import axios from 'axios';
import router from '../router';
import ElementUI from 'element-ui'
import {
  isWafChallengeResponse,
  showWafChallenge,
  applyWafTokensToConfig,
  clearWafTokens
} from './waf'

let service = axios.create({
  headers: {},
  withCredentials: true
})
axios.defaults.baseURL = ""
axios.defaults.withCredentials = true

let loading;
function startLoading() {
  loading = Vue.prototype.$loading({
    lock: true,
    text: "加载中...",
    background: "rgba(0, 0, 0, .7)",
    // fullscreen: false
    // target: document.querySelector('.loading-area')//设置加载动画区域
  });
}
function endLoading() {
  loading.close();
}

//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
};
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
};

/**
 * 遇到 WAF 验证页：弹窗验证 → 重试原请求
 * @param {string} html 验证页 HTML
 * @param {Object} originalConfig 原请求配置
 * @returns {Promise<*>}
 */
function retryAfterWafChallenge(html, originalConfig) {
  return showWafChallenge(html).then(function () {
    return service(Object.assign({}, originalConfig))
  })
}

/**
 * 本请求若拼接过 WAF 参数，响应后清掉 sessionStorage（保留 cookie）
 * @param {Object} config 请求配置
 */
function clearSessionParamsIfNeeded(config) {
  if (config && config.__wafParamsAttached) {
    clearWafTokens()
  }
}

// 添加请求拦截器
service.interceptors.request.use(function (config) {
  applyWafTokensToConfig(config)

  if(config.showLoading !== false){
      showFullScreenLoading();
  }

  return config
}, function (error) {
  tryHideFullScreenLoading();
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use(function (response) {
  tryHideFullScreenLoading();

  if (isWafChallengeResponse(response)) {
    return retryAfterWafChallenge(response.data, response.config)
  }

  clearSessionParamsIfNeeded(response.config)

  let urlFilter = []
  let data = response.data
  let codeArr = [18000]   //过滤掉状态
  let logoutCode = [18001, 20015, 20007, 20008, 20204]
  if (data && data.code) {
    if (!codeArr.includes(data.code) && !urlFilter.includes(response.config.url.split('v1')[1])) {
      ElementUI.Message({
        message: data.msg,
        type: 'error'
      })
    }
    if (logoutCode.includes(data.code) && !urlFilter.includes(response.config.url.split('v1')[1])) {
      store.commit('REMOVE_USER');
      // router.push('/login');
      location.href = 'https://www.qx.com/Account/Login';
    }
  }

  if (response.data && response.data.code == "20009") {
    ElementUI.Message({
      message: data.msg,
      type: 'error'
    })
  }
  return response.data
}, function (error) {
  tryHideFullScreenLoading();
  if (error.response && isWafChallengeResponse(error.response)) {
    return retryAfterWafChallenge(error.response.data, error.config)
  }
  clearSessionParamsIfNeeded(error.config)
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/plugins/axios.js